<h2 mat-dialog-title>{{ 'ACT_BULK_EDIT' | translate }}</h2>

<mat-dialog-content>
	<p>{{ selectedRows.length }} {{ 'ACT_BULK_EDIT_SUBTITLE' | translate }}</p>

	<div *ngIf="isLoading || isSaving" class="loading-container">
		<mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
	</div>

	<div *ngIf="!isLoading && errorOccurred" class="error-container">
		<mat-icon color="warn">error</mat-icon>
		<span>{{ 'ERROR_LOADING_LAYOUT' | translate }}</span>
	</div>

	<div *ngIf="!isLoading && !isSaving && !errorOccurred" class="form-container">
		<div *ngFor="let column of firstSectionDatas" class="field-row">
			<div class="field-header-row">
				<span class="field-label"
					  [matTooltip]="column.columnLabel | translate">{{ column.columnLabel | translate }}</span>
				<span *ngIf="!column.isRequiredField" class="field-clear-label">{{ "FILTER_CLEAR" | translate }} </span>
			</div>

			<div class="field-input-row">
				<div class="field-input">
					<ng-container [ngSwitch]="column.type">

						<ng-container *ngSwitchCase="'DTY_LIST'">
							<custom-ext-select [(defaultValue)]="formData[column.columnName]"
											   [values]="(tableController.filterValues | async)[column.columnName]"
											   [searchable]="true"
											   [disabled]="clearedFields[column.columnName]"
											   class="w-100"
							>
							</custom-ext-select>
						</ng-container>

						<ng-container *ngSwitchCase="'DTY_DATE'">
							<custom-datepicker [(value)]="formData[column.columnName]"
											   [disabled]="clearedFields[column.columnName]">
							</custom-datepicker>
						</ng-container>

						<ng-container *ngSwitchCase="'DTY_TIME'">
							<custom-timepicker [(value)]="formData[column.columnName]"
											   [disabled]="clearedFields[column.columnName]">
							</custom-timepicker>
						</ng-container>

						<ng-container *ngSwitchCase="'DTY_YES_NO'">
							<custom-checkbox [(ngModel)]="formData[column.columnName]"
											 [trueValue]="'Y'"
											 [falseValue]="'N'"
											 [disabled]="clearedFields[column.columnName]">
							</custom-checkbox>
						</ng-container>

						<ng-container *ngSwitchDefault>
							<custom-text-field [(value)]="formData[column.columnName]"
											   [isNumber]="column.type == 'DTY_INT' || column.type == 'DTY_FLOAT'"
											   [disabled]="clearedFields[column.columnName] ?? false">
							</custom-text-field>
						</ng-container>

					</ng-container>
				</div>

				<mat-checkbox *ngIf="!column.isRequiredField" class="field-clear ms-4"
							  [(ngModel)]="clearedFields[column.columnName]"
							  (change)="onClearField(column.columnName, $event.checked)">
				</mat-checkbox>
			</div>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="close()" [disabled]="isSaving">{{ 'ACT_CLOSE' | translate }}</button>
	<button mat-raised-button color="primary" style="color: white" (click)="save()" [disabled]="isLoading || errorOccurred || isSaving">
		<span style="color: white">
			{{ 'LABEL_SAVE' | translate }}
		</span>
	</button>
</mat-dialog-actions>